import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Card } from 'react-bootstrap';

import entidadesFederativas from '../../../support/catalogs/EntidadesFederativas';

const ComplementoParcialesConstruccionResumen = ({ data = {}, onEdit, onDelete }) => {

  const estado = entidadesFederativas.find((item) => {
    return item.value === data.Inmueble.Estado;
  });

  const handleOnDelete = () => {
    onDelete('parcialesconstruccion');
  }

  const handleOnEdit = () => {
    onEdit('parcialesconstruccion', data);
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">Servicios Parciales Construcción, Versión { data.Version }</Card.Subtitle>

        <Row className="mt-3">
          <Col className="py-2">
            <strong>Número de permiso, licencia o autorización: </strong>
            { data.NumPerLicoAut }
            <br/>
          </Col>

        </Row>

        <Row className="py-2">
          <Col>
            <Row>
              <Col sm md="6">
              <strong>Calle: </strong>
              { data.Inmueble.Calle }
              <br/>

              <strong>Num: </strong>
              { data.Inmueble.NoExterior }

              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

              <strong>Int: </strong>
              { data.Inmueble.NoInterior }
              <br/>

              <strong>Colonia: </strong>
              { data.Inmueble.Colonia }
              <br/>

              <strong>Referencia: </strong>
              { data.Inmueble.Referencia }
              <br/>
              </Col>

              <Col sm md="6">
                <strong>Localidad: </strong>
                { data.Inmueble.Localidad }
                <br/>

                <strong>Municipio: </strong>
                { data.Inmueble.Municipio }
                <br/>

                <strong>Estado: </strong>
                { data.Inmueble.Estado } { !!estado && estado.label }
                <br/>

                <strong>CP: </strong>
                { data.Inmueble.CodigoPostal }
                <br/>
              </Col>
            </Row>

          </Col>
        </Row>

        <Row>
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoParcialesConstruccionResumen;
